import { lazy, type ComponentType, type LazyExoticComponent } from 'react'

type IconComponent = ComponentType<{ size?: number | string }>

// PERF-6: single webpack chunk for all archetype icons to avoid 9 separate requests
const ICON_MAP: Record<string, () => Promise<{ default: IconComponent }>> = {
  seeker: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeSeeker/index'),
  mystic: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeMystic/index'),
  alchemist: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeAlchemist/index'),
  explorer: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeExplorer/index'),
  rebel: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeRebel/index'),
  guardian: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeGuardian/index'),
  healer: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeHealer/index'),
  visionary: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeVisionary/index'),
  observer: () => import(/* webpackChunkName: "archetype-icons" */ '../../../../components/Icon/icons/ArchetypeObserver/index'),
}

/**
 * Returns a React.lazy component for the given archetype key,
 * or null if the key is unrecognized.
 *
 * Each icon is code-split and loaded on demand to keep the main
 * bundle small (~1M mobile users).
 */
export default function getArchetypeIcon (
  key: string,
): LazyExoticComponent<IconComponent> | null {
  const loader = ICON_MAP[key]
  return loader ? lazy(loader) : null
}
